module.exports = __webpack_public_path__ + "static/media/explore.0c408839.jpeg";